export default __webpack_public_path__ + "static/media/Wrath of the Dark Sun.0d816698.jpg";